import { render, staticRenderFns } from "./PointBuy.vue?vue&type=template&id=61380319&scoped=true"
import script from "./PointBuy.vue?vue&type=script&lang=js"
export * from "./PointBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61380319",
  null
  
)

export default component.exports